import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
} from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import validator from '../common/validator';
import * as SVGICONS from '../../images/img/images';
import { ToastContainer, toast } from 'react-toastify';
import * as gapiActions from '../../actions/gapiActions';
import 'react-toastify/dist/ReactToastify.css';

var countries = require('country-data').countries;
const autoBind = require('auto-bind');
//login container component
class CalendarEmailInput extends React.Component {
    constructor(props, context) {
        super(props, context);
        console.log('props', this.props.actions)
        this.state = {
            forgotModalOpen: false,
            spinner: false,
            email: { value: '', isValid: true, message: '' },
        };
        //binding current context to all functions
        this.onChange = this.onChange.bind(this);
        this.onOtpSubmit = this.onOtpSubmit.bind(this);
    }


    onOtpSubmit() {

        let obj = {
            // userId: this.state.loginData._id,
            iCloudEmailAddress: this.state.email.value
        }

        this.props.gapiActions.storeUseriCloudEmail(obj);

    }
    onChange(e) {
        var state = this.state;
        state[e.target.name].value = e.target.value;
        // this.resetValidationStates();
        if (e.target.name == "email") {
            if (e.target.value.length > 0) {
                if (!validator.isEmail(state.email.value)) {
                    state.email.isValid = false;
                    state.email.message = 'Not a valid email address';
                    this.setState(state);
                } else {
                    state.email.message = '';
                    state.email.isValid = true;
                    // return true
                }
            } else {
                state.email.isValid = false;
                state.email.message = 'Email address is required';
                this.setState(state);
            }
            this.setState(state);
        }
    }

    componentWillReceiveProps = (nextPropsToReceive) => {
        if (nextPropsToReceive.gapi.user_icloud_sync_option === true) {
            this.props.icloudEmailModalClose();
        }
    }

    render() {

        console.log("props", this.props)
        // this.props.history.push("/dashboard")
        var { email } = this.state;
        return (
            <Modal show={this.props.icloudEmailModalOpen} size="modal-sm" onHide={this.props.icloudEmailModalClose}>
                <Modal.Header>
                    {/* <ModalClose onClick={} /> */}
                    <Modal.Title><img src={require('../../images/images/logo.svg')} alt="" /></Modal.Title>
                    {/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
                </Modal.Header>
                <Modal.Body>

                    <div className="signIn "> Enter your iCloud Email Address</div>
                    <div className="userSpecialist">
                    </div >
                    <div className="loginInput">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend">
                                    <SVGICONS.EmailSvg />
                                </span>
                            </div>
                            <input type="text" name="email" className="form-control"
                                placeholder="Enter iCloud Email Address" value={this.state.email.value} onChange={this.onChange} />
                            <span className="help-block">{email.message}</span>
                        </div>
                        {/* <ToastContainer /> */}

                        <div className="btngrouplogIn">
                            <button className="btn btn-primary btn-signup" data-toggle="modal" onClick={this.onOtpSubmit}> Submit {this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal >
        );
    }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
    return {
        signin: state.signin,
        otpVerified: state.signin.otpVerified,
		gapi: state.gapi,
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        gapiActions: bindActionCreators(gapiActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CalendarEmailInput);
